import React from 'react';
import PropTypes from 'prop-types';
import ButtonEdit from '../ButtonEdit';
import View from './View';
import Edit from './Edit';

const Event = ({
  edit,
  confirm,
  deleteDate,
  enabled,
  confirmed,
  showDaysOfWeekField,
  showListOfDates,
  blockedDays,
  showDatePicker,
  showCustomDatePicker,
  eventName,
  eventDates,
  eventFrequency,
  daysOfWeek,
  eventTotalGuests,
  eventPerformersCount,
  eventGoods,
  eventFood,
  eventExhibition,
  valid,
  mobileDisplay,
  price,
  aboutEventRef,
  additionalCoverageRef,
  scrollToPosition,
  venueUtcOffset,
  performersList,
  foodVendorsList,
  goodsVendorsList,
  exhibitorsList,
  performersFrequency,
  goodsVendorsFrequency,
  foodVendorsFrequency,
  exhibitorsFrequency,
  canManageSettings,
}) => (
  <div
    className={`component ${enabled ? 'enabled' : 'disabled'}`}
    ref={aboutEventRef}
  >
    <div className="form-row justify-content-between">
      <div className="col-auto my-auto">
        <h3>About Your Event</h3>
      </div>
      <ButtonEdit edit={edit} show={confirmed} />
    </div>
    <div className="card">
      <div className="card-body">
        {!confirmed ? (
          <Edit
            enabled={enabled}
            confirm={confirm}
            deleteDate={deleteDate}
            show={!confirmed}
            valid={valid}
            showDaysOfWeekField={showDaysOfWeekField}
            showListOfDates={showListOfDates}
            blockedDays={blockedDays}
            eventDates={eventDates}
            eventTotalGuests={eventTotalGuests}
            showDatePicker={showDatePicker}
            showCustomDatePicker={showCustomDatePicker}
            mobileDisplay={mobileDisplay}
            additionalCoverageRef={additionalCoverageRef}
            scrollToPosition={scrollToPosition}
            venueUtcOffset={venueUtcOffset}
            eventPerformersCount={eventPerformersCount}
            eventGoods={eventGoods}
            eventFood={eventFood}
            eventExhibition={eventExhibition}
            performersFrequency={performersFrequency}
            goodsVendorsFrequency={goodsVendorsFrequency}
            foodVendorsFrequency={foodVendorsFrequency}
            exhibitorsFrequency={exhibitorsFrequency}
            canManageSettings={canManageSettings}
          />
        ) : (
          <View
            eventName={eventName}
            showListOfDates={showListOfDates}
            eventDates={eventDates}
            eventFrequency={eventFrequency}
            daysOfWeek={daysOfWeek}
            eventTotalGuests={eventTotalGuests}
            eventPerformersCount={eventPerformersCount}
            eventGoods={eventGoods}
            eventFood={eventFood}
            eventExhibition={eventExhibition}
            show={confirmed}
            price={price}
            performersList={performersList}
            foodVendorsList={foodVendorsList}
            goodsVendorsList={goodsVendorsList}
            exhibitorsList={exhibitorsList}
            performersFrequency={performersFrequency}
            goodsVendorsFrequency={goodsVendorsFrequency}
            foodVendorsFrequency={foodVendorsFrequency}
            exhibitorsFrequency={exhibitorsFrequency}
          />
        )}
      </div>
    </div>
  </div>
);
Event.propTypes = {
  edit: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  deleteDate: PropTypes.func.isRequired,
  enabled: PropTypes.bool.isRequired,
  confirmed: PropTypes.bool.isRequired,
  showDaysOfWeekField: PropTypes.bool.isRequired,
  showListOfDates: PropTypes.bool.isRequired,
  showDatePicker: PropTypes.bool.isRequired,
  blockedDays: PropTypes.arrayOf(PropTypes.number).isRequired,
  showCustomDatePicker: PropTypes.bool.isRequired,
  eventName: PropTypes.string.isRequired,
  eventDates: PropTypes.arrayOf(PropTypes.string).isRequired,
  eventFrequency: PropTypes.string.isRequired,
  daysOfWeek: PropTypes.arrayOf(PropTypes.number).isRequired,
  eventTotalGuests: PropTypes.string.isRequired,
  eventPerformersCount: PropTypes.string.isRequired,
  eventGoods: PropTypes.string.isRequired,
  eventFood: PropTypes.string.isRequired,
  eventExhibition: PropTypes.string.isRequired,
  valid: PropTypes.bool.isRequired,
  mobileDisplay: PropTypes.bool.isRequired,
  price: PropTypes.number.isRequired,
  scrollToPosition: PropTypes.func.isRequired,
  additionalCoverageRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
  aboutEventRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
  venueUtcOffset: PropTypes.number.isRequired,
  performersList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      days: PropTypes.string,
    }),
  ),
  foodVendorsList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      days: PropTypes.string,
    }),
  ),
  goodsVendorsList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      days: PropTypes.string,
    }),
  ),
  exhibitorsList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      days: PropTypes.string,
    }),
  ),
  performersFrequency: PropTypes.string.isRequired,
  goodsVendorsFrequency: PropTypes.string.isRequired,
  foodVendorsFrequency: PropTypes.string.isRequired,
  exhibitorsFrequency: PropTypes.string.isRequired,
  canManageSettings: PropTypes.bool.isRequired,
};

Event.defaultProps = {
  performersList: null,
  foodVendorsList: null,
  goodsVendorsList: null,
  exhibitorsList: null,
};

export default Event;
